import { Autocomplete, Box, Grid, IconButton, TextField, Typography, useMediaQuery, useTheme } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import { useAppDispatch, useAppSelector } from "../Redux/store";
import { setResult, setSearch } from "../Pages/Marketplace/Slices/marketplaceSearchSlice";
import { useEffect } from "react";
import { ArrowBack, ClearOutlined } from "@mui/icons-material";
import { useSearchMutation } from "../Redux/api/searchApi";
import { useNavigate } from "react-router-dom";
import { useToast } from "../Hooks/useToast";
import { resetPrevLocation, setShowBackButton } from "../Redux/slices/GlobalSlice";

export const Searchbar = () => {
    /* ******************** Hooks ******************** */
    const theme = useTheme();
    const { showToast } = useToast();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [search, {data: searchResponse, isLoading: isSearching}] = useSearchMutation();
    /* ******************** Variables ******************** */
    const searchValue = useAppSelector(state => state.MarketplaceSearch.Search);
    const result = useAppSelector( state => state.MarketplaceSearch.Result);
    const globalSlice = useAppSelector( state => state.Global);
    const smMatch = useMediaQuery(theme.breakpoints.down('sm'));
    const onSearchPage = window.location.href.includes('search');
    /* ******************** Functions ******************** */
    const handleSearchInput = (val: string) => {
        dispatch(setSearch(val))
    }

    const handleSearchClick  = () => {                    
        search({context: globalSlice.userType === 'talent' ? 'job': 'talent', term: searchValue})
        .unwrap()
        .then( res =>{
            dispatch(setResult(res))
            if (!onSearchPage) navigate('/marketplace/search');
        })
        .catch( err => {
            console.log(err)
            showToast({
                text: 'Error occured while searching',
                variant: 'error'
            })
        })
    }
    /* ******************** Effects ******************** */
    useEffect(() => {
        if (searchValue.length == 0) {
            if (result.length > 0) dispatch(setResult([]))
            if (onSearchPage)navigate(-1)
        }
    }, [searchValue])
    /* ******************** JSX ******************** */
    return (
        <Box 
          display={"flex"}
          flexDirection={'row'} 
          paddingTop={"28px"}
          marginX={2}
          gridArea={"b"}
        >
            {
                globalSlice.showBackButton && !smMatch && 
                <Grid flex={1} display={"flex"} flexDirection={'row'} justifyContent={'flex-start'} paddingLeft={2}>
                    <IconButton
                        onClick={() => {
                            navigate(globalSlice.prevLocation)
                            dispatch(resetPrevLocation());
                            dispatch(setShowBackButton(false));
                        }}
                    >
                        <ArrowBack sx={{ marginRight: 1}} />
                        <Typography>Back</Typography>
                    </IconButton>
                </Grid> 
            }           
            <Grid flex={4} display={"flex"} flexDirection={'row'} justifyContent={globalSlice.showBackButton ? 'flex-start': 'center'}>
                <Box
                    width={"100%"}
                    maxWidth={'700px'}
                    sx={{
                        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":{
                            border: "none",
                        },
                        ".MuiInputBase-root":{
                            background: theme.palette.green[50],
                            borderRadius: "58px",
                            paddingRight: "16px !important"
                        },
                        ".Mui-expanded": {
                            ".MuiInputBase-root":{
                                borderRadius: "28px 28px 0 0",
                                border: "none"
                            },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
                                border: "none"
                            },
                        },
                        ".MuiAutocomplete-popper": {
                            ".MuiPaper-root":{
                                borderRadius: "0 0 28px 28px"
                            },
                        }
                    }}
                >
                    <Autocomplete
                        disablePortal
                        freeSolo
                        autoComplete
                        fullWidth
                        includeInputInList
                        options={[searchValue]}
                        value={searchValue}
                        onKeyDown={(params) => {
                            if (params.code === "Enter") handleSearchClick()
                        }}
                        // onChange={(event) => console.log(event)/*dispatch(setSearch(event.target.value))*/}
                        onInputChange={(event, value) => handleSearchInput(value)}          
                        componentsProps={{
                            popper:{
                                keepMounted: true,
                                sx: {
                                    borderRadius: "0 0 28px 28px",
                                }
                            }
                        }}                
                        renderInput={(params) =>(                        
                            <TextField 
                                {...params}
                                placeholder="Search"
                                color="primary"
                                sx={{
                                    border: "none"
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment:  
                                        searchValue.length > 0 ? 
                                        <IconButton 
                                            onClick={() => dispatch(setSearch(""))}
                                        > 
                                            <ClearOutlined color="primary" />
                                        </IconButton> :
                                        <IconButton>
                                            <SearchIcon color="primary" />
                                        </IconButton>
                                }}
                            />
                        )}
                    />
                </Box>
            </Grid>
        </Box>
    )
}